var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.756816 11.7429C0.928295 11.9144 1.09965 12 1.35688 12C1.61398 12 1.78546 11.9142 1.95695 11.7429L6.49985 7.19998L11.0427 11.7429C11.2142 11.9144 11.4713 12 11.6428 12C11.8143 12 12.0714 11.9142 12.2429 11.7429C12.5857 11.4001 12.5857 10.8857 12.2429 10.5429L7.69998 6L12.2429 1.4571C12.5857 1.11427 12.5857 0.599952 12.2429 0.257122C11.9 -0.0857074 11.3857 -0.0857074 11.0429 0.257122L6.5 4.80002L1.9571 0.257122C1.61427 -0.0857074 1.09995 -0.0857074 0.757122 0.257122C0.414293 0.599952 0.414293 1.11427 0.757122 1.4571L5.30002 6L0.757122 10.5429C0.414293 10.8859 0.414293 11.4001 0.757122 11.743L0.756816 11.7429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/XIcon.ab8542d62f2dbb35e85dd7981e99799f.svg";
export { ForwardRef as ReactComponent };